/**
 * @fileoverview POST handler for the "/:app_group_id/operator_mcp_connections" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppGroupIdOperatorMcpConnectionsCacheKeys } from "./constants";
import type {
  PostAppGroupIdOperatorMcpConnectionsProps,
  PostAppGroupIdOperatorMcpConnectionsResult,
} from "./types";

export const postAppGroupIdOperatorMcpConnections = reactQueryMutationAdapter(
  postAppGroupIdOperatorMcpConnectionsCacheKeys,
  ({
    appGroupId,
    name,
    displayName,
    serverUrl,
    clientId,
    clientSecret,
  }: PostAppGroupIdOperatorMcpConnectionsProps): Promise<PostAppGroupIdOperatorMcpConnectionsResult> => {
    // Field errors are shown on the form, not in the global modal.
    return fetch(
      `/${appGroupId}/operator_mcp_connections`,
      "POST",
      {
        name,
        display_name: displayName,
        server_url: serverUrl,
        client_id: clientId,
        client_secret: clientSecret,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
